import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { DeliveryAddressService, ReceiptService, ServicesService } from '@checkout-v2/feature';
import { ReceiptAddressComponent } from './receipt-address';
import { ReceiptTypeTabsComponent } from './receipt-type-tabs';
import { ServicesComponent } from './services';
import { TimeSlotsComponent } from './time-slots';

@Component({
  selector: 'sd-receipt',
  imports: [ReceiptTypeTabsComponent, ReceiptAddressComponent, ServicesComponent, TimeSlotsComponent],
  templateUrl: './receipt.component.html',
  styleUrl: './receipt.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReceiptComponent {
  private readonly receiptService = inject(ReceiptService);
  private readonly deliveryAddressService = inject(DeliveryAddressService);
  private readonly servicesService = inject(ServicesService);

  protected readonly activeReceiptTypeId = toSignal(this.receiptService.getActiveReceiptTypeId());

  protected readonly isAddressListEmptyOrHasError = toSignal(this.deliveryAddressService.isEmptyOrHasError());
  protected readonly isDeliveryAddressValid = toSignal(this.deliveryAddressService.isValid());

  protected readonly isServiceListEmptyOrHasError = toSignal(this.servicesService.isEmptyOrHasError());
  protected readonly isServicesValid = toSignal(this.servicesService.isValid());
}
